import { logout, logoutBeacon } from '../api/logout';
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import '../css/Navbar.css';
import '../css/DarkMode.css';
import CatmatUploadModal from './modalServices/CatmatUploadModal';
// 1. Importe o novo modal
// ChangeAnoBaseModal removed — year control is inline in the navbar
import PdfConfirmModal from './modals/PdfConfirmModal';
import LoadingModal from './modals/LoadingModal';
import DefaultModal from './modals/DefaultModal';
import ChangePasswordModal from './modals/ChangePasswordModal';
import usePdfConfirmModal from './hooks/usePdfConfirmModal';
import useDefaultModal from './hooks/useDefaultModal';
import useDarkMode from './hooks/useDarkMode';
import { relatoriosGlobais, gerarPcaDocx } from '../utils/relatoriosGlobais';
import { isAdminBase, isAdminAuthorized, isSuperAdmin } from '../../utils/userUtils';

function Navbar({ toggleSidebar }) {
    // Logout ao fechar aba/navegador
    useEffect(() => {
      const handleUnload = () => {
        const token = localStorage.getItem('token');
        if (token) {
          logoutBeacon(token);
          // Removido localStorage.removeItem('token') para evitar logout ao atualizar
        }
      };
      window.addEventListener('beforeunload', handleUnload);
      return () => window.removeEventListener('beforeunload', handleUnload);
    }, []);
    // Função para logout via botão
    const handleLogout = () => {
      const token = localStorage.getItem('token');
      logout(token)
        .then(() => {
          localStorage.removeItem('token');
          try { sessionStorage.setItem('justLoggedOut','true'); sessionStorage.removeItem('loginRedirectMessage'); } catch (e) { }
          navigate('/');
        })
        .catch(() => {
          localStorage.removeItem('token');
          try { sessionStorage.setItem('justLoggedOut','true'); sessionStorage.removeItem('loginRedirectMessage'); } catch (e) { }
          navigate('/');
        });
    };
  const [user, setUser] = useState(null);
  const [appCliente, setAppCliente] = useState(null);
  const [usuarioBind, setUsuarioBind] = useState(null);
  const [anoBase, setAnoBase] = useState(null);
  const [inputAno, setInputAno] = useState(new Date().getFullYear());
  const [vinculosCount, setVinculosCount] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const [showCatmatUploadModal, setCatmatUploadModal] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const { pdfModalData, showPdfModal, closePdfModal, handleConfirm } =
    usePdfConfirmModal();
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  // modal removed: use inline controls to change year
  const [otherTabsOpen, setOtherTabsOpen] = useState(false);
  const [showImportacaoApi, setShowImportacaoApi] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const [openNestedSubmenu, setOpenNestedSubmenu] = useState(null);
  const [relatorioLoading, setRelatorioLoading] = useState(false);

  const gerarRelatorio = async (action) => {
    setRelatorioLoading(true);
    try {
      await action(navigate);
    } catch (err) {
      console.error('Erro ao gerar relatório:', err);
    } finally {
      setRelatorioLoading(false);
    }
  };
  const importOpenTimer = useRef(null);
  const importCloseTimer = useRef(null);
  const firstImportItemRef = useRef(null);
  const importButtonRef = useRef(null);

  // Detecta outras abas abertas usando Broadcast Channel com heartbeat
  useEffect(() => {
    const channel = new BroadcastChannel('app_tabs_channel');
    let pongReceived = false;
    let heartbeatInterval;
    let pongTimeout;

    const checkOtherTabs = () => {
      pongReceived = false;
      
      // Envia ping para verificar se há outras abas
      channel.postMessage({ type: 'ping', timestamp: Date.now() });
      
      // Aguarda resposta por 1 segundo
      pongTimeout = setTimeout(() => {
        if (!pongReceived) {
          // Nenhuma resposta recebida, sem outras abas
          setOtherTabsOpen(false);
        }
      }, 1000);
    };

    // Escuta mensagens de outras abas
    const handleMessage = (event) => {
      if (event.data.type === 'ping') {
        // Outra aba está ativa, responde com pong
        channel.postMessage({ type: 'pong', timestamp: Date.now() });
        setOtherTabsOpen(true);
      } else if (event.data.type === 'pong') {
        // Recebeu resposta de outra aba
        pongReceived = true;
        setOtherTabsOpen(true);
        if (pongTimeout) {
          clearTimeout(pongTimeout);
        }
      }
    };

    channel.addEventListener('message', handleMessage);
    
    // Inicia verificação a cada 3 segundos
    checkOtherTabs();
    heartbeatInterval = setInterval(checkOtherTabs, 3000);

    // Cleanup
    return () => {
      channel.removeEventListener('message', handleMessage);
      clearInterval(heartbeatInterval);
      if (pongTimeout) {
        clearTimeout(pongTimeout);
      }
      channel.close();
    };
  }, []);


  useEffect(() => {
    // ... (seu código useEffect existente permanece o mesmo)
    if (localStorage.getItem('token') === null) {
      navigate('/');
    }
    const userData = localStorage.getItem('user');
    if (userData) {
      setUser(JSON.parse(userData));
    } else {
      navigate('/');
    }
    const appClienteData = localStorage.getItem('appCliente');
    if (appClienteData) {
      setAppCliente(JSON.parse(appClienteData));
    }
    const usuarioBindData = localStorage.getItem('usuarioBind');
    if (usuarioBindData) {
      setUsuarioBind(JSON.parse(usuarioBindData));
    }
    const anoBaseData = localStorage.getItem('anoBase');
    if (anoBaseData) {
      setAnoBase(JSON.parse(anoBaseData));
    }
    
    // Carregar o número de vínculos
    const userBindData = localStorage.getItem('userBind');
    if (userBindData) {
      try {
        const parsedVinculos = JSON.parse(userBindData);
        setVinculosCount(Array.isArray(parsedVinculos) ? parsedVinculos.length : 1);
      } catch (error) {
        setVinculosCount(1);
      }
    }
  }, [navigate]);

  // Quando o submenu é aberto por teclado, foca o primeiro item para acessibilidade
  useEffect(() => {
    if (showImportacaoApi) {
      // pequeno timeout para garantir que o elemento esteja disponível
      const t = setTimeout(() => {
        firstImportItemRef.current?.focus();
      }, 60);
      return () => clearTimeout(t);
    }
  }, [showImportacaoApi]);

  // Monitora mudanças na rota e mostra orientação caso a flag esteja ativa
  useEffect(() => {
    if (location.pathname === '/home') {
      const shouldOpenModal = localStorage.getItem('openAnoBaseModal');
      if (shouldOpenModal === 'true') {
        localStorage.removeItem('openAnoBaseModal');
        setTimeout(() => {
          showDefaultModal('info', 'Use os controles de ano na barra superior para alterar o Ano Base.');
        }, 300);
      }
    }
  }, [location.pathname, showDefaultModal]);

  // Sincroniza o input com o anoBase atual
  useEffect(() => {
    setInputAno(anoBase || new Date().getFullYear());
  }, [anoBase]);

  // Altera o ano base com as mesmas restrições do submenu
  const handleChangeAnoBase = newAno => {
    if (!newAno) return;
    if (otherTabsOpen) {
      showDefaultModal(
        'error',
        'Não é possível trocar o ano base enquanto houver outras abas do sistema abertas. \n- Por favor, feche todas as outras abas antes de prosseguir. \n- Clique em F5 se as outras abas já foram fechadas.'
      );
      return;
    }
    try {
      localStorage.setItem('anoBase', String(newAno));
      setAnoBase(newAno);
      setInputAno(newAno);
      // Notifica outras partes da aplicação que o ano base mudou
      try {
        window.dispatchEvent(new CustomEvent('anoBaseChanged', { detail: { anoBase: newAno } }));
      } catch (evErr) {
        // fallback simples
        window.dispatchEvent(new Event('anoBaseChanged'));
      }
      window.location.reload();
    } catch (err) {
      console.error('Erro ao alterar ano base', err);
    }
  };

  // Se outras abas forem detectadas, apenas notifica o usuário
  useEffect(() => {
    if (otherTabsOpen) {
      showDefaultModal('error', 'O sistema detectou outras abas abertas. Feche-as para trocar o Ano Base.');
    }
  }, [otherTabsOpen, showDefaultModal]);

  // Estado controla submenu 'Importação API' para evitar fechamento do dropdown pai

  if (!user || !usuarioBind) {
    // Adicionado 'usuarioBind' para evitar erros de renderização inicial
    return <div>Loading...</div>;
  }

  const isActive = path =>
    location.pathname === path ? 'nav-link active px-2 text-white' : 'nav-link px-2 text-white';

  const isDropdownItemActive = path =>
    location.pathname === path ? 'dropdown-item text-white active' : 'dropdown-item text-white';

  // Função para verificar se o dropdown deve estar ativo baseado nas páginas do submenu
  const isDropdownActive = menuPaths => {
    const isMenuActive = menuPaths.some(path => location.pathname === path);
    return isMenuActive
      ? 'nav-link active px-2 text-white'
      : 'nav-link px-2 text-white';
  };

  // Função para verificar se o submenu principal (Cadastro) deve estar ativo
  const isCadastroActive = () => {
    const cadastroPaths = [
      '/clientes',
      '/usuarios',
      '/usuario_vinculos',
      '/requisitantes',
      '/responsabilidades',
      '/upload_imagem',
      '/unidades_medidas',
      '/tipos_objetos',
      '/margens_config',
      '/catmat_import',
      '/catmat_um_import',
      '/catser_import',
      '/catser_um_import',
    ];
    return isDropdownActive(cadastroPaths);
  };

  // Função para verificar se o menu DFD deve estar ativo (incluindo subpáginas)
  const isDfdActive = () => {
    const dfdPaths = [
      '/dfds',
      '/dfd_itens',
      '/dfd_lotes',
      '/dfd_lote_itens',
    ];
    const isDfdMenuActive = dfdPaths.some(
      path => location.pathname === path || location.pathname.startsWith(path)
    );
    return isDfdMenuActive ? 'nav-link active px-2 text-white' : 'nav-link px-2 text-white';
  };

  // Função para verificar se o menu PCA deve estar ativo (incluindo subpáginas)
  const isPcaActive = () => {
    const pcaPaths = ['/pca'];
    const isPcaMenuActive = pcaPaths.some(
      path => location.pathname === path || location.pathname.startsWith(path)
    );
    return isPcaMenuActive ? 'nav-link active px-2 text-white' : 'nav-link px-2 text-white';
  };

  return (<>
    <nav
      className="navbar navbar-expand-lg navbar-dark fixed-top shadow-sm"
      style={{
        background:
          'linear-gradient(90deg, #0b3383, #0e48ad)',
      }}
    >
      <div className="container-fluid">
        <button
          className="btn text-white d-lg-none me-2 p-1"
          onClick={toggleSidebar}
          style={{ fontSize: '1.2rem', lineHeight: 1 }}
        >
          <i className="bi bi-list"></i>
        </button>
        <a>
          <img
            src="/assets/logo.png"
            alt="Logo"
            width="120"
            height="40"
            className="d-inline-block align-top me-2 rounded-0"
          />
        </a>
        <div className="d-none d-lg-flex align-items-center" style={{ minWidth: 'max-content' }}>
          <span className="text-white-50 me-2" style={{ fontSize: '1em', lineHeight: 1 }}>|</span>
          <div className="d-flex flex-column">
            {appCliente && appCliente.nome && (
              <span className="nav-link p-0 text-white" style={{ fontSize: '0.7em', lineHeight: 1, marginBottom: '2px' }}>
                {appCliente.nome}
              </span>
            )}
            {appCliente && appCliente.logrCidade && appCliente.logrUf && (
              <span className="nav-link p-0 text-white" style={{ fontSize: '0.55em', lineHeight: 1, marginBottom: '2px' }}>
                {appCliente.logrNome}{appCliente.logrNum ? `, ${appCliente.logrNum}` : ''}{appCliente.logrCompl ? ` - ${appCliente.logrCompl}` : ''}{appCliente.logrBairro ? ` - ${appCliente.logrBairro}` : ''} - {appCliente.logrCidade}/{appCliente.logrUf}{appCliente.logrCep ? ` · CEP ${appCliente.logrCep.replace(/^(\d{5})(\d{3})$/, '$1-$2')}` : ''}
              </span>
            )}
            {appCliente && appCliente.cnpj && (
              <span className="nav-link p-0 text-white" style={{ fontSize: '0.55em', lineHeight: 1 }}>
                CNPJ: {appCliente.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')}
              </span>
            )}
          </div>
        </div>
        <div className="ms-auto">
          <ul className="navbar-nav custom-align">
            {/* Indicador de outras abas abertas */}
            {/* {otherTabsOpen && (
              <li className="nav-item">
                <span 
                  className="nav-link" 
                  style={{ fontSize: '0.7em', color: '#ffc107' }}
                  title="Outras abas abertas detectadas"
                >
                  <i className="bi bi-window-stack me-1"></i>
                  Múltiplas abas
                </span>
              </li>
            )} */}
            {/* Desktop: ano base + info usuário + dropdown */}
            <li className="nav-item d-none d-lg-flex align-items-center me-3">
              <div className="input-group input-group-sm">
                <button
                  type="button"
                  className="input-group-text"
                  onClick={() => handleChangeAnoBase((anoBase || new Date().getFullYear()) - 1)}
                  aria-label="Ano anterior"
                  style={{ cursor: 'pointer' }}
                >
                  <i className="bi bi-chevron-left" />
                </button>
                <input
                  type="text"
                  inputMode="numeric"
                  className="input-group-text text-center"
                  style={{ width: '60px' }}
                  value={inputAno}
                  readOnly
                  aria-label="Ano base (somente leitura)"
                />
                <button
                  type="button"
                  className="input-group-text"
                  onClick={() => handleChangeAnoBase((anoBase || new Date().getFullYear()) + 1)}
                  aria-label="Próximo ano"
                  style={{ cursor: 'pointer' }}
                >
                  <i className="bi bi-chevron-right" />
                </button>
              </div>
            </li>
            <li className="nav-item user-info d-none d-lg-flex flex-column align-items-end me-3" style={{ minWidth: 'max-content' }}>
              {user.nome && (
                <span className="nav-link p-0 text-white" style={{ fontSize: '0.8em', lineHeight: 1 }}>
                  {user.nome}
                </span>
              )}
            </li>
            <li className="nav-item dropdown compact d-none d-lg-flex">
              <Link
                className="nav-link dropdown-toggle text-white"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
              </Link>
              <ul
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby="navbarDropdown"
                style={{ minWidth: '250px' }}
              >
                {vinculosCount > 1 && (
                  <>
                    <li>
                      <button
                        className="nav-link px-2 text-white"
                        onClick={() => navigate('/seleciona_entidade')}
                        style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
                      >
                        <i className="bi bi-arrow-left-right me-2" />
                        Trocar Entidade
                      </button>
                    </li>
                    {isAdminAuthorized(user, usuarioBind) && (
                      <li>
                        <button
                          className="nav-link px-2 text-white"
                          onClick={() => navigate('/sessions_ativas')}
                          style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
                        >
                          <i className="bi bi-list-task me-2" />
                          Sessões
                        </button>
                      </li>
                    )}
                  </>
                )}
                {/* <li>
                  <button
                    className="nav-link px-2"
                    onClick={toggleDarkMode}
                    style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
                    title={isDarkMode ? 'Desativar modo escuro' : 'Ativar modo escuro'}
                  >
                    <i className={`bi ${isDarkMode ? 'bi-brightness-high' : 'bi-moon'} me-2`} />
                    {isDarkMode ? 'Desativar' : 'Ativar'} Modo Escuro
                  </button>
                </li> */}
                <li>
                  <button
                    className="nav-link px-2"
                    onClick={() => setShowChangePassword(true)}
                    style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
                  >
                    <i className="bi bi-key me-2" />
                    Alterar senha
                  </button>
                </li>
                <li>
                  <hr className="dropdown-divider bg-white border " />
                </li>
                <li>
                  <button
                    className="nav-link px-2"
                    onClick={handleLogout}
                    style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
                  >
                    <i className="bi bi-power me-2" />
                    Sair
                  </button>
                </li>
              </ul>
            </li>

            {/* Mobile: ícone usuário com dropdown unificado */}
            <li className="nav-item dropdown d-flex d-lg-none">
              <Link
                className="nav-link dropdown-toggle text-white"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="bi bi-person-circle" style={{ fontSize: '1.3rem' }}></i>
              </Link>
              <ul className="dropdown-menu dropdown-menu-end" style={{ minWidth: '220px' }}>
                <li className="px-3 py-2">
                  {user.nome && (
                    <div className="text-white fw-semibold" style={{ fontSize: '0.8em' }}>{user.nome}</div>
                  )}
                  {appCliente && appCliente.nome && (
                    <div className="text-white-50" style={{ fontSize: '0.7em' }}>{appCliente.nome}</div>
                  )}
                </li>
                <li><hr className="dropdown-divider bg-white border" /></li>
                <li className="px-3 py-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="text-white me-2" style={{ fontSize: '0.8em' }}>Ano Base</span>
                    <div className="input-group input-group-sm" style={{ width: 'auto' }}>
                      <button
                        type="button"
                        className="input-group-text"
                        onClick={() => handleChangeAnoBase((anoBase || new Date().getFullYear()) - 1)}
                        style={{ cursor: 'pointer' }}
                      >
                        <i className="bi bi-chevron-left" />
                      </button>
                      <input
                        type="text"
                        inputMode="numeric"
                        className="input-group-text text-center"
                        style={{ width: '50px' }}
                        value={inputAno}
                        readOnly
                      />
                      <button
                        type="button"
                        className="input-group-text"
                        onClick={() => handleChangeAnoBase((anoBase || new Date().getFullYear()) + 1)}
                        style={{ cursor: 'pointer' }}
                      >
                        <i className="bi bi-chevron-right" />
                      </button>
                    </div>
                  </div>
                </li>
                <li><hr className="dropdown-divider bg-white border" /></li>
                {vinculosCount > 1 && (
                  <>
                    <li>
                      <button
                        className="nav-link px-2 text-white"
                        onClick={() => navigate('/seleciona_entidade')}
                        style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
                      >
                        <i className="bi bi-arrow-left-right me-2" />
                        Trocar Entidade
                      </button>
                    </li>
                    {isAdminAuthorized(user, usuarioBind) && (
                      <li>
                        <button
                          className="nav-link px-2 text-white"
                          onClick={() => navigate('/sessions_ativas')}
                          style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
                        >
                          <i className="bi bi-list-task me-2" />
                          Sessões
                        </button>
                      </li>
                    )}
                  </>
                )}
                <li>
                  <button
                    className="nav-link px-2"
                    onClick={toggleDarkMode}
                    style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
                  >
                    <i className={`bi ${isDarkMode ? 'bi-brightness-high' : 'bi-moon'} me-2`} />
                    {isDarkMode ? 'Desativar' : 'Ativar'} Modo Escuro
                  </button>
                </li>
                <li>
                  <button
                    className="nav-link px-2"
                    onClick={() => setShowChangePassword(true)}
                    style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
                  >
                    <i className="bi bi-key me-2" />
                    Alterar senha
                  </button>
                </li>
                <li><hr className="dropdown-divider bg-white border" /></li>
                <li>
                  <button
                    className="nav-link px-2"
                    onClick={handleLogout}
                    style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
                  >
                    <i className="bi bi-power me-2" />
                    Sair
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        {/* 4. Renderize os modais no final do componente */}
        <CatmatUploadModal
          show={showCatmatUploadModal}
          onClose={() => setCatmatUploadModal(false)}
        />
        {/* ChangeAnoBaseModal removed: year control is inline */}
        <LoadingModal loading={relatorioLoading} />
        <PdfConfirmModal
          show={pdfModalData.show}
          onClose={closePdfModal}
          onConfirm={handleConfirm}
          title={pdfModalData.title}
          message={pdfModalData.message}
          isLoading={pdfModalData.isLoading}
        />
        <DefaultModal
          show={setDefaultModal.show}
          type={setDefaultModal.type}
          message={setDefaultModal.message}
          onClose={setDefaultModal.onClose}
        />
        <ChangePasswordModal show={showChangePassword} onClose={() => setShowChangePassword(false)} />
      </div>
    </nav>
      
    </>
  );
}

export default Navbar;
